import { S3Config } from 'dashboard/models/external-integration';
import Action from 'lib/interfaces/Action';

export enum S3ActionType {
  SetS3Config = 'S3/SET_S3_CONFIG',
}

export type S3Actions = Action<S3ActionType.SetS3Config, SetS3ConfigPayload>;

export interface SetS3ConfigPayload {
  s3Config: S3Config;
}

export function setS3Config(
  s3Config: S3Config,
): Action<S3ActionType.SetS3Config, SetS3ConfigPayload> {
  return {
    payload: { s3Config },
    type: S3ActionType.SetS3Config,
  };
}
